module.exports = __webpack_public_path__ + "media/images/salon de jardin-dba6c2d1a74a73eb3ecbe557198bdf86.svg";